import React from 'react';
import ReservationScheduleComponent from './index';

export default function ReservationScheduleComponent3(props) {
    return <ReservationScheduleComponent {...props} sharedBookingTooltip />;
}
